<template>
    <div class="sec" :class="{ 'sec-bare': !sectionLabel }">
        <div class="sec-label" v-if="sectionLabel">{{ sectionLabel }}</div>

        <div class="invoice-box">
            <!-- ===== Quotation / Price ===== -->
            <v-row>
                <v-col cols="12" md="3">
                    <div class="field-label">เลขที่ใบเสนอราคา / Quotation ID</div>
                    <v-autocomplete :value="salesOrderId" :items="salesOrderList" item-value="quotation_id"
                        item-text="doc_no" placeholder="SO-69-0001" outlined dense hide-details="auto"
                        background-color="white" clearable :disabled="readonly" @change="onSelectSO" />
                </v-col>
                <v-col cols="12" md="3">
                    <div class="field-label">Customer Name</div>
                    <v-text-field :value="customerName" outlined dense hide-details="auto" placeholder="—"
                        background-color="#f2f2f2" disabled />
                </v-col>
                <v-col cols="12" md="3">
                    <div class="field-label">Price</div>
                    <v-text-field :value="price" type="number" outlined dense hide-details="auto" placeholder="฿"
                        background-color="#f2f2f2" disabled />
                </v-col>
                <v-col cols="12" md="2">
                    <div class="field-label">Currency</div>
                    <v-text-field :value="currency" outlined dense hide-details="auto" placeholder="—"
                        background-color="#f2f2f2" disabled />
                </v-col>
            </v-row>

            <!-- ===== ยังไม่มี Invoice: แสดงช่อง placeholder ทั้งหมด (disabled) ===== -->
            <v-row v-if="!hasInvoice">
                <v-col cols="12" md="3">
                    <div class="field-label">
                        เลขที่ Invoice
                        <v-tooltip top max-width="260">
                            <template #activator="{ on, attrs }">
                                <span class="info-tag" v-bind="attrs" v-on="on">i</span>
                            </template>
                            <span>แนะนำเพิ่ม: บันทึกเลขบิลเมื่อออกแล้ว เพื่อตรวจสอบย้อนหลัง</span>
                        </v-tooltip>
                    </div>
                    <v-text-field placeholder="INV-… (auto เมื่อออก)" disabled outlined dense hide-details="auto"
                        background-color="#f2f2f2" />
                </v-col>
                <v-col cols="12" md="3">
                    <div class="field-label">วันที่ออก Invoice</div>
                    <v-text-field placeholder="dd/mm/yyyy" readonly disabled outlined dense hide-details="auto"
                        append-icon="mdi-calendar" background-color="#f2f2f2" />
                </v-col>
                <v-col cols="12" md="3">
                    <div class="field-label">วันครบกำหนดชำระ</div>
                    <v-text-field placeholder="dd/mm/yyyy" readonly disabled outlined dense hide-details="auto"
                        append-icon="mdi-calendar" background-color="#f2f2f2" />
                </v-col>
                <v-col cols="12" md="3">
                    <div class="field-label">
                        Invoice Status
                        <v-tooltip top max-width="260">
                            <template #activator="{ on, attrs }">
                                <span class="info-tag" v-bind="attrs" v-on="on">i</span>
                            </template>
                            <span>หัวใจของโมดูล: ติดตามรอบบิลแบบเดียวกับ Immigration</span>
                        </v-tooltip>
                    </div>
                    <v-select placeholder="auto เมื่อออก" :items="invoiceStatusList" outlined dense hide-details="auto"
                        background-color="#f2f2f2" disabled />
                </v-col>
            </v-row>

            <!-- ===== มี Invoice แล้ว: แสดงรายการจริง (อ่านอย่างเดียว) ===== -->
            <template v-else>
                <v-row v-for="item in invoiceList" :key="item.id">
                    <v-col cols="12" md="3">
                        <div class="field-label">
                            เลขที่ Invoice
                            <v-tooltip top max-width="260">
                                <template #activator="{ on, attrs }">
                                    <span class="info-tag" v-bind="attrs" v-on="on">i</span>
                                </template>
                                <span>แนะนำเพิ่ม: บันทึกเลขบิลเมื่อออกแล้ว เพื่อตรวจสอบย้อนหลัง</span>
                            </v-tooltip>
                        </div>
                        <v-text-field :value="item.invoice_display" placeholder="INV-… (auto เมื่อออก)" disabled
                            outlined dense hide-details="auto" background-color="#f2f2f2" />
                    </v-col>
                    <v-col cols="12" md="3">
                        <div class="field-label">วันที่ออก Invoice</div>
                        <v-text-field :value="item.created_at" disabled placeholder="dd/mm/yyyy" readonly outlined dense
                            hide-details="auto" append-icon="mdi-calendar" background-color="#f2f2f2" />
                    </v-col>
                    <v-col cols="12" md="3">
                        <div class="field-label">วันครบกำหนดชำระ</div>
                        <v-text-field :value="item.inv_date" disabled placeholder="dd/mm/yyyy" readonly outlined dense
                            hide-details="auto" append-icon="mdi-calendar" background-color="#f2f2f2" />
                    </v-col>
                    <v-col cols="12" md="2">
                        <div class="field-label">
                            Invoice Status
                            <v-tooltip top max-width="260">
                                <template #activator="{ on, attrs }">
                                    <span class="info-tag" v-bind="attrs" v-on="on">i</span>
                                </template>
                                <span>หัวใจของโมดูล: ติดตามรอบบิลแบบเดียวกับ Immigration</span>
                            </v-tooltip>
                        </div>
                        <v-text-field :value="item.invoice_status" placeholder="auto เมื่อออก" outlined dense
                            hide-details="auto" background-color="#f2f2f2" disabled />
                    </v-col>
                    <v-col cols="12" md="1" class="d-flex align-center justify-center" style="margin-top: 24px;">
                        <v-tooltip top>
                            <template #activator="{ on, attrs }">
                                <v-btn icon color="primary" v-bind="attrs" v-on="on" @click="$emit('preview', item)">
                                    <v-icon>mdi-eye</v-icon>
                                </v-btn>
                            </template>
                            <span>ดูรายละเอียด</span>
                        </v-tooltip>
                    </v-col>
                </v-row>
            </template>
        </div>
    </div>
</template>

<script>
export default {
    name: "InvoiceSectionPanel",
    props: {
        salesOrderId: { type: [Number, String], default: "" },
        // ชื่อลูกค้าจาก quotation ที่เลือก (แสดงอย่างเดียว)
        customerName: { type: String, default: "" },
        price: { type: [Number, String], default: "" },
        // สกุลเงินจาก quotation ที่เลือก (แสดงอย่างเดียว)
        currency: { type: String, default: "" },
        salesOrderList: { type: Array, default: () => [] },
        invoiceList: { type: Array, default: () => [] },
        invoiceStatusList: { type: Array, default: () => ["Draft", "Requested", "Invoiced", "Paid"] },
        sectionLabel: { type: String, default: "E · การเงิน & สถานะ Invoice" },
        readonly: { type: Boolean, default: false },
    },
    computed: {
        hasInvoice() {
            return Array.isArray(this.invoiceList) && this.invoiceList.length > 0;
        },
    },
    methods: {
        onSelectSO(value) {
            // ส่งทั้ง value (สำหรับ .sync) และ object เต็มของ quotation ที่เลือก
            // ให้ parent เอาไปคำนวณ price / เก็บ status เองได้ ไม่ต้องไปค้นซ้ำ
            this.$emit("update:salesOrderId", value);
            const selected = this.salesOrderList.find((item) => item.quotation_id === value) || null;
            this.$emit("select-so", selected);
        },
    },
};
</script>

<style scoped>
.sec {
    border-top: 1px solid #d4d9e0;
    margin-top: 22px;
    padding-top: 18px;
}

.sec-label {
    font-size: 11px;
    text-transform: uppercase;
    letter-spacing: 1px;
    color: #1b7a99;
    font-weight: 700;
    margin-bottom: 14px;
}

.field-label {
    font-size: 12.5px;
    color: #37424f;
    margin-bottom: 5px;
    display: flex;
    align-items: center;
    gap: 6px;
    min-height: 18px;
}

.info-tag {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 18px;
    height: 18px;
    border-radius: 50%;
    background: #c47f00;
    color: #fff;
    font-size: 11px;
    font-weight: 700;
    cursor: help;
}

.invoice-box {
    background: #f7fafc;
    border: 1px solid #d8e6f0;
    border-radius: 8px;
    padding: 16px;
}


/* ไม่มี section label = ถูกครอบด้วย card/หัวข้อของหน้าแม่อยู่แล้ว
   จึงไม่ต้องมีเส้นคั่นและระยะห่างด้านบนของตัวเอง */
.sec-bare {
    border-top: none;
    margin-top: 0;
    padding-top: 0;
}
</style>